export default "__VITE_ASSET__Boour1FP__"